/**
 * @generated SignedSource<<96b615e5c2f9347848f2c22cbe71d4b7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "auditDetail"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "auditType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "changeByAccount"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "changedByEmail"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customerAppId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v11 = [
  {
    "kind": "Variable",
    "name": "auditdetail",
    "variableName": "auditDetail"
  },
  {
    "kind": "Variable",
    "name": "audittype",
    "variableName": "auditType"
  },
  {
    "kind": "Variable",
    "name": "changebyaccount",
    "variableName": "changeByAccount"
  },
  {
    "kind": "Variable",
    "name": "changedbyemail",
    "variableName": "changedByEmail"
  },
  {
    "kind": "Variable",
    "name": "customerappid",
    "variableName": "customerAppId"
  },
  {
    "kind": "Variable",
    "name": "direction",
    "variableName": "direction"
  },
  {
    "kind": "Variable",
    "name": "endts",
    "variableName": "endDate"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "orderby",
    "variableName": "orderBy"
  },
  {
    "kind": "Variable",
    "name": "startts",
    "variableName": "startDate"
  }
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerAppAuditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "CustomerAppAuditEntriesConnection",
        "kind": "LinkedField",
        "name": "customerappauditsearch",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CustomerAppAuditList_al"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v10/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "CustomerAppAuditQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": "CustomerAppAuditEntriesConnection",
        "kind": "LinkedField",
        "name": "customerappauditsearch",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerAppAuditEntry",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerAppAuditId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "auditAccountId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "auditAccountName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userFirstname",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userLastname",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "auditType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "auditDetail",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "orderId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "created",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d4b5512cdfb21487ff8b8f38043aa82b",
    "id": null,
    "metadata": {},
    "name": "CustomerAppAuditQuery",
    "operationKind": "query",
    "text": "query CustomerAppAuditQuery(\n  $startDate: Datetime\n  $endDate: Datetime\n  $customerAppId: UUID!\n  $auditDetail: String\n  $changeByAccount: String\n  $changedByEmail: String\n  $auditType: Int\n  $orderBy: Int\n  $direction: Int\n  $first: Int\n  $offset: Int\n) {\n  customerappauditsearch(startts: $startDate, endts: $endDate, customerappid: $customerAppId, auditdetail: $auditDetail, changebyaccount: $changeByAccount, changedbyemail: $changedByEmail, audittype: $auditType, orderby: $orderBy, direction: $direction, first: $first, offset: $offset) {\n    totalCount\n    ...CustomerAppAuditList_al\n  }\n}\n\nfragment CustomerAppAuditList_al on CustomerAppAuditEntriesConnection {\n  nodes {\n    customerAppAuditId\n    auditAccountId\n    auditAccountName\n    userId\n    userFirstname\n    userLastname\n    auditType\n    auditDetail\n    orderId\n    created\n  }\n}\n"
  }
};
})();

node.hash = "da94098d844168508647fb9aff9c1ce8";

module.exports = node;
